import { ref } from "vue";

export enum Dialogs {
  UserLoginForm = "userLoginForm",
  QuizModal = "quizModal",
}

export const useDialogsStore = defineStore("dialogs", () => {
  const dialogs = ref({
    [Dialogs.UserLoginForm]: false, // Whether the user login form modal is open
    [Dialogs.QuizModal]: false,
  });

  const openDialog = (dialog: Dialogs) => {
    dialogs.value[dialog] = true;
  };

  const closeDialog = (dialog: Dialogs) => {
    dialogs.value[dialog] = false;
  };

  const showDialog = (dialog: Dialogs) => {
    return dialogs.value[dialog];
  };

  return {
    dialogs,
    showDialog,
    openDialog,
    closeDialog,
  };
});
